import Cookies from '../utilities/Cookies';

const gtmEvent = (category = '', action = '', label = '') => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		eventCategory: category,
		eventAction: action,
		eventLabel: label,
		event: 'GAevent',
		utm_source: Cookies.get('utm_source'),
		utm_medium: Cookies.get('utm_medium'),
		utm_campaign: Cookies.get('utm_campaign'),
	});
};

export default gtmEvent;
